<template>
  <div>
    <!-- Product feature list start -->
    <section class="hot-features-area" id="productsDetail">
      <div class="container animated bounceInUp">
        <div class="section-header-2 wow fadeIn" data-wow-offset="10" data-wow-duration="1.5s">
          <div class="section-description" style="z-index: 999;">
            <p class="features-title">
              <span>Products Of <span style="font-weight: 600;">ANOVATOR</span></span>
            </p>
          </div>
        </div>
        <div class="product-showcase-controls" aria-label="Product carousel controls">
          <button
            class="product-arrow"
            type="button"
            aria-label="Show previous product"
            :disabled="currentIndex === 0"
            @click="showPreviousProduct"
          >
            <span aria-hidden="true">←</span>
          </button>
          <button
            class="product-arrow"
            type="button"
            aria-label="Show next product"
            :disabled="currentIndex >= maxIndex"
            @click="showNextProduct"
          >
            <span aria-hidden="true">→</span>
          </button>
        </div>
        <div
          ref="productViewport"
          class="product-showcase-viewport"
          aria-label="ANOVATOR products"
          @scroll.passive="handleViewportScroll"
        >
          <div
            ref="productTrack"
            class="product-showcase-track"
            :style="{ transform: `translate3d(-${trackOffset}px, 0, 0)` }"
          >
            <article
              v-for="product in products"
              :key="product.key"
              class="product-features product-card"
              :class="product.productClass"
              :style="{ '--product-image': `url(${product.image})` }"
            >
              <h3 class="model-name">{{ product.name }}</h3>
              <div class="product-function-list">
                <div
                  v-for="feature in product.features"
                  :key="feature.name"
                  class="function-item"
                >
                  <div :class="feature.enabled ? 'tick-ico' : 'untick-ico'" aria-hidden="true">
                    {{ feature.enabled ? '✔' : '×' }}
                  </div>
                  <div class="function-name">{{ feature.name }}</div>
                </div>
              </div>
              <button class="btn-more" type="button" @click="goToProduct(product.key)">MORE</button>
            </article>
          </div>
        </div>
      </div>
    </section>
    <!-- Product feature list end -->

    <!-- Global presence section start -->
    <section class="hot-features-area">
      <div class="container animated bounceInUp">
        <div class="section-header-2 wow fadeIn" data-wow-offset="10" data-wow-duration="1.5s">
          <div class="section-description" style="z-index: 999;">
            <p class="features-title">
              <span><span style="font-weight: 600;">ANOVATOR</span> On the way</span>
            </p>
          </div>
        </div>
        <div class="row hot-features" style="padding: 0;position: relative;">
          <div class="dealer-box">
            <div class="indicator">
              11.84M+
              <div>Tests</div>
            </div>
            <div class="indicator">
              8.42M+
              <div>User</div>
            </div>
            <div class="indicator">
              200M+
              <div>Records</div>
            </div>
            <div class="indicator">
              20,598+
              <div>Supporting stores</div>
            </div>
            <div class="indicator">
              50+
              <div>Countries</div>
            </div>
          </div>
          <img
            class="img-responsive map-img"
            src="/static/images/map.png"
            data-src="https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/image/map%402x.png"
            alt="Global presence map"
          >
        </div>
      </div>
    </section>
    <!-- Global presence section end -->
  </div>
</template>

<script>
export default {
  name: 'ProductShowcase',
  data() {
    const legacyFeatures = [
      'Body composition analysis',
      'Athletic capacity Analysis',
      'Sp02',
      'Sports safety Analysis',
      'Balance Assessment',
      'Heart Rate Test',
      'Response Assessment',
      'Body posture Analysis',
      'Detection Data Analysis',
      'Visual acuity Assessment',
      'Shoulder Joint Range of motionEvaluation Function',
      'Test Report'
    ]
    const createFeatures = enabledIndexes => legacyFeatures.map((name, index) => ({
      name,
      enabled: enabledIndexes.includes(index)
    }))

    return {
      products: [
        {
          key: 'p5',
          name: 'ANOVATOR P5',
          route: '/p5',
          image: '/static/images/p5/home-product-p5-transparent-final.png',
          productClass: 'p5-item',
          features: [
            'Body Composition Analysis',
            'Body Dimensions & Posture',
            'Vital Capacity Assessment',
            'Balance Ability Assessment',
            'Agility Reaction Assessment',
            'Blood Pressure & Blood Oxygen',
            'Lower Limb Explosive Power Test',
            'Push-up Upper Body Strength Assessment',
            'Grip Strength Test',
            'Test Report'
          ].map(name => ({ name, enabled: true }))
        },
        {
          key: 'a5',
          name: 'ANOVATOR A5',
          route: '/a5',
          image: '/static/images/A5@2x.png',
          productClass: 'a5-item',
          features: createFeatures([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11])
        },
        {
          key: 'm3',
          name: 'ANOVATOR M3',
          route: '/m3',
          image: '/static/images/M3@2x.png',
          productClass: 'm3-item',
          features: createFeatures([0, 1, 2, 3, 7, 8, 10, 11])
        },
        {
          key: 'm1',
          name: 'ANOVATOR M1',
          route: '/m1',
          image: '/static/images/M1@2x.png',
          productClass: 'm1-item',
          features: createFeatures([0, 7, 8, 11])
        },
        {
          key: 'm0',
          name: 'ANOVATOR M0',
          route: '/m0',
          image: '/static/images/M0@2x.png',
          productClass: 'm0-item',
          features: createFeatures([0, 8, 11])
        }
      ],
      currentIndex: 0,
      visibleCount: 1,
      cardStep: 0,
      maximumOffset: 0,
      isMobile: false,
      resizeFrame: null
    }
  },
  computed: {
    maxIndex() {
      return Math.max(0, this.products.length - this.visibleCount)
    },
    trackOffset() {
      if (this.isMobile) {
        return 0
      }
      return Math.min(this.currentIndex * this.cardStep, this.maximumOffset)
    }
  },
  mounted() {
    this.$nextTick(this.updateMeasurements)
    window.addEventListener('resize', this.handleResize)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize)
    if (this.resizeFrame) {
      window.cancelAnimationFrame(this.resizeFrame)
    }
  },
  methods: {
    updateMeasurements() {
      const viewport = this.$refs.productViewport
      const track = this.$refs.productTrack
      const card = track && track.querySelector('.product-card')

      if (!viewport || !track || !card) {
        return
      }

      this.isMobile = window.matchMedia('(max-width: 767px)').matches
      const trackStyles = window.getComputedStyle(track)
      const gap = parseFloat(trackStyles.columnGap || trackStyles.gap) || 0
      const cardWidth = card.getBoundingClientRect().width
      this.cardStep = cardWidth + gap
      this.visibleCount = this.isMobile
        ? 1
        : Math.max(1, Math.floor((viewport.clientWidth + gap) / this.cardStep))
      this.maximumOffset = Math.max(0, track.scrollWidth - viewport.clientWidth)
      this.currentIndex = Math.min(this.currentIndex, this.maxIndex)

      if (!this.isMobile) {
        viewport.scrollLeft = 0
      }
    },
    handleResize() {
      if (this.resizeFrame) {
        window.cancelAnimationFrame(this.resizeFrame)
      }
      this.resizeFrame = window.requestAnimationFrame(() => {
        this.resizeFrame = null
        this.updateMeasurements()
      })
    },
    handleViewportScroll(event) {
      if (!this.isMobile || !this.cardStep) {
        return
      }
      this.currentIndex = Math.min(
        this.maxIndex,
        Math.max(0, Math.round(event.currentTarget.scrollLeft / this.cardStep))
      )
    },
    showPreviousProduct() {
      this.currentIndex = Math.max(0, this.currentIndex - 1)
    },
    showNextProduct() {
      this.currentIndex = Math.min(this.maxIndex, this.currentIndex + 1)
    },
    goToProduct(productName) {
      const product = this.products.find(item => item.key === productName)
      if (product) {
        this.$router.push(product.route)
      }
    }
  }
}
</script>

<style scoped>
.product-showcase-controls {
  display: flex;
  gap: 12px;
  margin: 38px 0 24px;
}

.product-arrow {
  align-items: center;
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.68);
  border-radius: 50%;
  color: #fff;
  cursor: pointer;
  display: inline-flex;
  font-size: 22px;
  height: 46px;
  justify-content: center;
  line-height: 1;
  padding: 0;
  transition: background-color 0.25s ease, border-color 0.25s ease, opacity 0.25s ease;
  width: 46px;
}

.product-arrow:hover:not(:disabled) {
  background: #ee0b6a;
  border-color: #ee0b6a;
}

.product-arrow:focus-visible,
.btn-more:focus-visible {
  outline: 2px solid #ee0b6a;
  outline-offset: 3px;
}

.product-arrow:disabled {
  cursor: not-allowed;
  opacity: 0.3;
}

.product-showcase-viewport {
  overflow: hidden;
  width: 100%;
}

.product-showcase-track {
  align-items: stretch;
  column-gap: 24px;
  display: flex;
  transition: transform 0.45s cubic-bezier(0.22, 1, 0.36, 1);
  width: max-content;
  will-change: transform;
}

.product-card {
  display: flex;
  flex: 0 0 330px;
  flex-direction: column;
  height: 650px;
  isolation: isolate;
  margin: 0;
  overflow: hidden;
}

.product-card::before {
  background-image: var(--product-image);
  background-repeat: no-repeat;
  bottom: 0;
  content: '';
  left: 0;
  opacity: 0.4;
  pointer-events: none;
  position: absolute;
  right: 0;
  top: 0;
  transition: opacity 0.5s ease, transform 0.35s ease;
  z-index: 0;
}

.product-card:hover::before {
  opacity: 1;
}

.product-card > * {
  position: relative;
  z-index: 1;
}

.product-card .model-name {
  margin: 0;
}

.product-function-list {
  min-height: 430px;
}

.product-card .btn-more {
  align-self: center;
  margin: auto 0 0;
}

.p5-item::before {
  background-position: right var(--p5-image-right) bottom var(--p5-image-bottom);
  background-size: var(--p5-image-size) auto;
  opacity: 0.62;
}

.p5-item {
  --p5-image-bottom: 250px;
  --p5-image-right: 12px;
  --p5-image-size: 46%;
}

.p5-item .product-function-list {
  background: linear-gradient(90deg, #000 0%, rgba(0, 0, 0, 0.92) 58%, transparent 88%);
}

.a5-item::before,
.m3-item::before {
  background-position: 135% 18%;
  background-size: 68%;
}

.m1-item::before {
  background-position: 127% 20%;
  background-size: 58%;
}

.m0-item::before {
  background-position: 108% 42%;
  background-size: 49%;
}

@media (max-width: 1100px) and (min-width: 768px) {
  .product-card {
    flex-basis: calc((100vw - 176px) / 2.2);
  }

  .p5-item::before {
    background-position: right var(--p5-image-right) bottom var(--p5-image-bottom);
  }

  .p5-item {
    --p5-image-bottom: 210px;
    --p5-image-right: 10px;
    --p5-image-size: 44%;
  }
}

@media (max-width: 767px) {
  .product-showcase-controls {
    display: none;
  }

  .product-showcase-viewport {
    margin-top: 28px;
    overflow-x: auto;
    overscroll-behavior-inline: contain;
    scroll-snap-type: x mandatory;
    scrollbar-width: none;
  }

  .product-showcase-viewport::-webkit-scrollbar {
    display: none;
  }

  .product-showcase-track {
    transform: none !important;
    transition: none;
  }

  .p5-item::before {
    background-position: right var(--p5-image-right) bottom var(--p5-image-bottom);
  }

  .p5-item {
    --p5-image-bottom: 315px;
    --p5-image-right: 8px;
    --p5-image-size: 44%;
  }

  .product-card {
    flex-basis: min(82vw, 320px);
    height: 700px;
    scroll-snap-align: start;
  }

  .product-function-list {
    min-height: 490px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .product-showcase-track,
  .product-card::before,
  .product-arrow {
    transition: none;
  }
}
</style>
